module.exports = __webpack_public_path__ + "static/media/create.e9dfebf9.svg";